<template>
  <div
    v-if="showConsent"
    class="cookie-consent max-w-full sm:max-w-[50vw] right-0 left-0 bottom-0 sm:right-20 sm:left-20 sm:bottom-20"
  >
    <div class="relative p-15 flex flex-col items-end sm:items-stretch sm:flex-row gap-10 bg-bgColor-global">
      <div class="sm:flex-1 flex flex-col gap-10">
        <p>
          {{ $t('CookieConsent.message') }}
        </p>
        <a v-if="linkShow" href="/privacy-policy" class="text-primary">{{ $t('CookieConsent.learnMore') }}</a>
      </div>
      <div class="flex flex-row-reverse sm:flex-col gap-10">
        <button class="btn text-[#fff] bg-primary border-primary" @click="accept">
          {{ $t('CookieConsent.accept') }}
        </button>
        <button class="btn text-primary border-primary bg-[#fff]" @click="reject">
          {{ $t('CookieConsent.reject') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showConsent: false
    }
  },
  computed: {
    linkShow() {
      const route = this.$route
      return route.name !== 'privacy-policy'
    }
  },
  created() {
    this.checkConsentStatus()
    window.addEventListener('pageshow', this.checkConsentStatus)
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.checkConsentStatus)
  },
  methods: {
    close() {
      this.showConsent = false
    },
    accept() {
      localStorage.setItem('cookieConsent', 'accepted')
      this.showConsent = false
      this.$emit('cookie-consent', 'accepted')

      this.updateConsentStatus(true)
    },
    reject() {
      localStorage.setItem('cookieConsent', 'rejected')
      this.showConsent = false
      this.$emit('cookie-consent', 'rejected')

      this.updateConsentStatus(false)
    },
    updateConsentStatus(consentGiven) {
      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({
        'gtm.consent': consentGiven ? 'true' : 'false',
        event: consentGiven ? 'consent_given' : 'consent_declined'
      })
    },
    checkConsentStatus() {
      const cookieConsent = localStorage.getItem('cookieConsent')
      if (!cookieConsent) {
        this.showConsent = true
      } else {
        this.showConsent = false
        if (cookieConsent === 'accepted') {
          this.updateConsentStatus(true)
        }
      }
    }
  }
}
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  z-index: 9999;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
}

.btn {
  padding: 8px 40px;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
}
</style>
